import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getPlans = () =>
  axiosInstance.get(`${ADMIN_API_URL}/packages`, {
    headers: authHeaders(),
  });

export const createPlanRequest = (planData) =>
  axiosInstance.post(`${ADMIN_API_URL}/package-features`, planData, {
    headers: authHeaders(),
  });

export const getPlanById = (planId) =>
  axiosInstance.get(`${ADMIN_API_URL}/packages/${planId}`, {
    headers: authHeaders(),
  });

export const updatePlanRequest = (planId, planData) =>
  axiosInstance.post(`${ADMIN_API_URL}/update-package-features/${planId}`, planData, {
    headers: authHeaders(),
  });

export const removePlan = (planId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/packages/${planId}`, {
    headers: authHeaders(),
  });
